<x-header-layout *ngIf="subscriber">
  <h2 xHeading>{{ subscriber.subscriptionName }}</h2>
  <button
    mat-icon-button
    xActionLeft
    xRedirectBack
    i18n-matTooltip="@@Tooltip.NavigateBack.Subscriptions"
    matTooltip="Back to subscriptions"
  >
    <fa-icon icon="chevron-left"></fa-icon>
  </button>

  <button mat-icon-button xActionRight class="d-lg-none close" xRedirectBack>
    <fa-icon icon="times"></fa-icon>
  </button>
</x-header-layout>
